import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common'

import { NgxUiLoaderService } from 'ngx-ui-loader';
import { TranslateService } from '@ngx-translate/core';

import { AccountService } from '../../account/account.service';
import { BuyerCondicoesService } from './condicoes.service';
import { NotificationService } from '../../_services/notification.service';

import { Pedido } from './_models/pedido';
import { Resposta } from './_models/resposta';
import { Peca } from './_models/peca';
import { ApiResponseModel } from '../../_models/apiResponseModel';
import { ConditionsApiResponse } from './_models/conditionsApiResponse';
import { Globals } from 'app/_models/globals';

declare const isEmpty: any;
declare const numberWithTwoDecimals: any;
declare const sort_by: any;

@Component({
    selector: 'app-condicoes', templateUrl: './condicoes.component.html', styleUrls: ['./condicoes.component.scss'],
    standalone: false
})
export class BuyerCondicoesComponent implements OnInit {
    isOnError: boolean;
    pedido: Pedido;
    transaction_id: number;

    respostas_compradas: Resposta[];
    respostas_nao_compradas: Resposta[];
    respostas_nao_respondida: Resposta[];
    respostas_nao_participando: Resposta[];

    constructor(public accountService: AccountService, private buyerCondicoesService: BuyerCondicoesService, private notificationService: NotificationService, private route: ActivatedRoute,
        private location: Location, private ngxLoader: NgxUiLoaderService, private translate: TranslateService, private globals: Globals) { }

    ngOnInit(): void {
        this.pedido = null;
        this.respostas_compradas = [];
        this.respostas_nao_compradas = [];

        var param_id = this.route.snapshot.params.id;
        var isValid = /^\d+$/.test(param_id);
        this.isOnError = !isValid;

        if (isValid) {
            this.transaction_id = parseInt(param_id);
            this.carregarTela(this.transaction_id);
        }
    }

    carregarTela(transaction_id) {
        this.ngxLoader.startLoader('loader-principal');

        this.buyerCondicoesService.listar(transaction_id).subscribe({
            next: (response: ApiResponseModel<ConditionsApiResponse>) => {
                if (response != null) {
                    this.pedido = { quotation_id: transaction_id, marca: response.result.brand, seguradora: response.result.insurance, veiculo: response.result.vehicle, respostas: response.result.answers };

                    this.definirTiposRespostas();

                    let todasPecas = this.pedido.respostas.map(r => r.pecas).reduce((acc, val) => acc.concat(val), []);
                    this.definirTooltipPrazo(todasPecas);
                }

                this.ngxLoader.stopLoader('loader-principal');
            },
            error: error => {
                console.log(error);

                if (error.status === 404) {
                    this.voltar({ corpo: 'buyer.condicoes.mensagens.listar.erro.nao-encontrado', parametro: transaction_id });
                    return;
                }

                this.ngxLoader.stopLoader('loader-principal');
            }
        });
    }

    definirTiposRespostas() {
        this.respostas_compradas = [];
        this.respostas_nao_compradas = [];
        this.respostas_nao_respondida = [];
        this.respostas_nao_participando = [];
        let buyerResponsabilityText = this.globals.translate('buyer.cotacao.area-respostas.resposta.rodape.frete.conta-comprador');
        let freeShippingText = this.globals.translate('buyer.mercado-partsfy.carrinho.footer.informacoes-preco.frete-gratis');

        if (isEmpty(this.pedido) || isEmpty(this.pedido.respostas))
            return;

        let respostas = this.pedido.respostas.sort(sort_by([{ name: 'vendedor' }]));
        respostas.map(r => {
            if (r.isAnswered) {
                let total = 0;

                r.pecas = r.pecas.map(p => {
                    p.shippingText = this.formatShipping(p, buyerResponsabilityText, freeShippingText);
                    total += numberWithTwoDecimals(p.quantity * (p.price * (100 - p.discount) / 100));
                    r.total = total + (p.shippingCost ?? 0);
                    return p;
                });
            }

            r.pecas.sort(sort_by([{ name: 'part_name' }]));
            this.setPaymentType(r);
        });

        let compradas: Resposta[] = respostas.filter(r => r.pecas.some(p => p.isChosen)).map(r => Object.assign({}, r));
        compradas.map(r => r.pecas = r.pecas.filter(p => p.isChosen));
        this.respostas_compradas = compradas;

        let nao_compradas: Resposta[] = respostas.filter(r => r.pecas.some(p => !p.isChosen)).map(r => Object.assign({}, r));
        nao_compradas.map(r => r.pecas = r.pecas.filter(p => !p.isChosen));
        this.respostas_nao_compradas = nao_compradas;
        this.respostas_nao_respondida = respostas.filter(r => !r.isAnswered);
        this.respostas_nao_participando = respostas.filter(r => r.isAnswered && r.pecas.length === 0);
    }

    definirTooltipPrazo(pecas: Peca[]) {
        pecas.map(peca => {
            let complemento_melhor_prazo = peca.deliveryTimeIsPF ? '.pf' : (peca.deliveryTimeIsBO ? '.bo' : '.pe');
            peca.tooltipPrazo =
                (peca.isBestDeliveryTime ?
                    'buyer.cotacao.area-respostas.resposta.pecas.melhor-prazo' + complemento_melhor_prazo :
                (peca.deliveryTimeIsPF ?
                        'buyer.cotacao.area-respostas.resposta.pecas.pedido-fabrica' :
                    (peca.deliveryTimeIsBO ?
                            'buyer.cotacao.area-respostas.resposta.pecas.back-order' :
                            'buyer.cotacao.area-respostas.resposta.pecas.peca-estoque'
                        )
                    )
                );
        });
    }

    formatShipping(p: Peca, buyerResponsabilityText: string, freeShippingText: string): string {
        let shippingFormatted = p.buyerResponsability ? buyerResponsabilityText : (isEmpty(p.shippingCost) ? freeShippingText : p.shippingCost.toString());
        return shippingFormatted;
    }

    selecionarPeca(peca) {
        let item_id = peca.item_id;
        this.pedido.respostas.map(r => r.pecas.map(p => { p.isSelected = p.itemId === item_id; }));
    }

    setPaymentType(answer: Resposta) {
        let paymentTypes = [];
        let part = answer.pecas.length > 0 ? answer.pecas[0] : null;

        if (!isEmpty(part) && part.canBeFinanced && !isEmpty(answer.paymentTypes)) {
            paymentTypes = answer.paymentTypes.filter(fp => fp.startValue <= answer.total && fp.paymentTypeId > 0).map(fp => fp.paymentType);
        }
        else if (answer?.paymentTypesFormatted?.length > 0 && part?.canBeFinanced) {
            paymentTypes.push({ texto_x: answer.paymentTypesFormatted[0].name, id: answer.paymentTypesFormatted[0].id });
        }

        let indexAVista = paymentTypes.findIndex(fp => fp.id == 0);

        if (indexAVista >= 0)
            paymentTypes.splice(indexAVista, 1);

        paymentTypes.push({ texto_x: this.globals.translate('buyer.cotacao.area-respostas.resposta.rodape.pagamento-a-vista'), id: 0 });
        paymentTypes.sort(sort_by([{ name: 'id', reverse: true }]));

        let isPaymentAVista = paymentTypes[0].id == 0;

        answer.paymentTypeTooltip = '';
        answer.paymentType = isPaymentAVista ? paymentTypes[0].texto_x : this.globals.translate('buyer.cotacao.area-comprar.selecionados.rodape.faturamento.faturado-ate') + paymentTypes[0].texto_x;

        if (!isPaymentAVista)
            return;

        if (!part?.canBeFinanced) {
            answer.paymentTypeTooltip = `${this.globals.translate('buyer.cotacao.area-respostas.resposta.rodape.faturamento-nao-liberado')} - ${this.globals.translate('buyer.cotacao.area-respostas.resposta.rodape.verificar-disponibilidade')}`;
            return;
        }

        answer.paymentTypeTooltip = this.globals.translate('buyer.cotacao.area-respostas.resposta.rodape.verificar-disponibilidade');
    }

    voltar(errorMessage: { corpo: string, parametro: any } | null) {
        if (!isEmpty(errorMessage)) {
            this.translate.get(errorMessage.corpo).subscribe(corpo => {
                this.notificationService.showErrorToastr(corpo.replace("#xxx", "#" + errorMessage.parametro));
            });
        }

        this.location.back();
    }
}
